import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { financialApi } from "./financial.api";
import { FinancialState, FinFilter } from "./types";

dayjs.extend(utc);
dayjs.extend(timezone);
const moscowTimeDate = dayjs().tz("Europe/Moscow");
const moscowTime = +moscowTimeDate.format("HH");
const today = dayjs().format("YYYY-MM-DD");
const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

export const SingleDate = moscowTime >= 11 ? today : yesterday;
export const RangeDate =
  moscowTime >= 11
    ? [dayjs(today).subtract(7, "day").format("YYYY-MM-DD"), today]
    : [dayjs(yesterday).subtract(7, "day").format("YYYY-MM-DD"), yesterday];

export const defaultFinFilter: FinFilter = {
  Date: SingleDate,
  FAccTypes: undefined,
  FCompanies: undefined,
};

const initialState: FinancialState = {
  filter: defaultFinFilter,
};

export const financialSlice = createSlice({
  name: "financial",
  initialState,
  reducers: {
    changeFilter: (state, { payload }) => {
      state.filter = { ...state.filter, [payload.key]: payload.value };
    },
    clearFinFilter: (state, { payload }) => {
      state.filter = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      financialApi.endpoints.finGetTypes.matchFulfilled,
      (state, { payload }) => {
        state.filter.FAccTypes = payload[1].value;
      },
    );
  },
});

export const { changeFilter, clearFinFilter } = financialSlice.actions;
export default financialSlice.reducer;
